import styled from '@emotion/styled'
import { WebLink } from '@news-mono/web-common'
import { colors } from '../../__styling/settings/colors'
import { fonts } from '../../__styling/settings/fonts'
import { metrics } from '../../__styling/settings/metrics'
import { zIndex } from '../../__styling/settings/z-index'
import { breakpoint } from '../../__styling/style-functions'
import { calcRem } from '../../__styling/style-functions/calc-rem'

const navScrollShadowSize = 30

export const StyledQuickLinks = styled('div')<{ hasBackgroundFill: boolean }>(
    ({ hasBackgroundFill }) => ({
        backgroundColor: hasBackgroundFill ? colors.white : undefined,
    }),
    {
        margin: '0 auto',

        [breakpoint('sm')]: {
            maxWidth: metrics.thewest.siteMetrics.mainContentWidth,
            padding: `0 ${calcRem(metrics.thewest.margins.outerMargin)}`,
        },
    },
)

export const StyledNav = styled('nav')({
    fontFamily: fonts.thewest.sansSerif,
    color: colors.thewest.greyGorilla,
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
})

export const StyledNavList = styled('ul')({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexWrap: 'nowrap',
    alignContent: 'center',
    textTransform: 'uppercase',
    fontWeight: 500,
    position: 'relative',
    overflowX: 'scroll',
    scrollbarWidth: 'none',
    whiteSpace: 'nowrap',
    WebkitOverflowScrolling: 'touch',
    MsOverflowStyle: 'none',

    '&::-webkit-scrollbar': {
        display: 'none',
    },

    backgroundImage: `
        radial-gradient(
            ellipse ${navScrollShadowSize}px 210% at ${
        navScrollShadowSize * -0.25
    }px center,
                ${colors.thewest.greyKoala} 0%,
                transparent 50%)
    `,

    // Mask the gradient until needed
    '&::before': {
        content: `''`,
        minWidth: 10,
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        zIndex: zIndex.thewest.mainNavScrollShadow,
        backgroundImage: `linear-gradient(to left, rgba(255, 255, 255, 0), ${colors.white} 40%)`,
    },
})

export const StyledNavItem = styled('li')({
    padding: calcRem(metrics.thewest.margins.sm),
    fontSize: calcRem(14),
})

export const StyledLink = styled(WebLink)(({ theme }) => ({
    textDecoration: 'none',
    transition: 'background 250ms ease-out',
    color: 'currentColor',

    '&:hover': {
        textDecoration: 'underline',
        color: theme.sectionValues.primaryColor,
    },

    '&:focus': {
        textDecoration: 'underline',
        outline: 'none',
    },
}))
